import { getPaymentDayStatusEndpoint } from 'cpfr-common';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CpDataApi } from '../../../../../../cp-xhr';
import { RootState } from '../../../../../../store/rootReducer';
import { paymentDayStatusTagFetchStateActions } from './usePaymentDayStatusTagSlice';

export const usePaymentDayStatusTag = () => {
    const dataValid = useSelector((state: RootState) => state.paymentDayStatusTagFetchState.dataValid);
    const inProgress = useSelector((state: RootState) => state.paymentDayStatusTagFetchState.inProgress);
    const isPaymentDayStatusTag = useSelector(
        (state: RootState) => state.paymentDayStatusTagFetchState.isPaymentDayStatusTag,
    );
    const dispatch = useDispatch();

    useEffect(() => {
        if (inProgress || dataValid) return;

        dispatch(paymentDayStatusTagFetchStateActions.setFetchProgress(true));
        dispatch(paymentDayStatusTagFetchStateActions.setDataValidity(true));

        CpDataApi.get(getPaymentDayStatusEndpoint())
            .then((response) => {
                if (response.data.requestCustomerStatus === 'IN_PROGRESS') {
                    dispatch(paymentDayStatusTagFetchStateActions.setIsPaymentDayStatusTag(true));
                    dispatch(paymentDayStatusTagFetchStateActions.setStatusTag(true));
                }
            })
            .catch(() => {
                dispatch(paymentDayStatusTagFetchStateActions.setIsPaymentDayStatusTag(false));
            })
            .finally(() => {
                dispatch(paymentDayStatusTagFetchStateActions.setFetchProgress(false));
            });
    }, [dispatch, dataValid, inProgress]);

    return isPaymentDayStatusTag;
};
